/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1UserUseridTemporaryPassword200,
  PostApiV1UserUseridTemporaryPassword400,
  PostApiV1UserUseridTemporaryPassword401,
  PostApiV1UserUseridTemporaryPassword500,
  PostApiV1UserUseridTemporaryPasswordMutationRequest,
  PostApiV1UserUseridTemporaryPasswordMutationResponse,
  PostApiV1UserUseridTemporaryPasswordPathParams,
} from "../../types/userCredenciaisController/PostApiV1UserUseridTemporaryPassword.ts";
import { setTemporaryPasswordRequestViewModelSchema } from "../setTemporaryPasswordRequestViewModelSchema.ts";

export const postApiV1UserUseridTemporaryPasswordPathParamsSchema = z.object({
  userId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1UserUseridTemporaryPasswordPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1UserUseridTemporaryPassword200Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridTemporaryPassword200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1UserUseridTemporaryPassword400Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridTemporaryPassword400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1UserUseridTemporaryPassword401Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridTemporaryPassword401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1UserUseridTemporaryPassword500Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridTemporaryPassword500>;

export const postApiV1UserUseridTemporaryPasswordMutationRequestSchema = z.lazy(
  () => setTemporaryPasswordRequestViewModelSchema,
) as unknown as ToZod<PostApiV1UserUseridTemporaryPasswordMutationRequest>;

export const postApiV1UserUseridTemporaryPasswordMutationResponseSchema =
  z.lazy(
    () => postApiV1UserUseridTemporaryPassword200Schema,
  ) as unknown as ToZod<PostApiV1UserUseridTemporaryPasswordMutationResponse>;
